<p-dialog [(visible)]="visivel" [style]="{width: '450px'}" header="Novo ambiente" [modal]="true" styleClass="p-fluid" (onHide)="escondeDialog()">
 <ng-template pTemplate="content">
    <div class="field">
        <label for="nome">Nome:</label>
        <input id="nome" pInputText type="text" [(ngModel)]="ambiente.ambiente" required autofocus>
        <small class="p-error" *ngIf="ambienteEnviado && !ambiente.ambiente">Nome é obrigatório.</small>
    </div>
    <div class="field">
        <label for="base">Base de dados:</label>
        <p-dropdown [style]="{'width':'100%'}" appendTo="body" [options]="bases" optionValue="id" optionLabel="nome" [(ngModel)]="ambiente.baseId" dataKey="id" inputId="id" placeholder="Selecione uma base" emptyMessage="Nenhuma base disponível"></p-dropdown>
        <small class="p-error" *ngIf="ambienteEnviado && !ambiente.base">Base é obrigatório.</small>
    </div>
    <div class="field">
        <label for="urlpims">URL do Serviço PIMS</label>
        <input id="urlpims" pInputText type="text" [(ngModel)]="ambiente.urlApiPims" required>
    </div>
    <div class="field">
        <label for="urlerp">URL do Serviço ERP</label>
        <input id="urlerp" pInputText type="text" [(ngModel)]="ambiente.urlApiErp" required>
    </div>
    <div class="field">
        <p-checkbox id="produtivo" label="Ambiente de produção" [(ngModel)]="ambiente.produtivo" [binary]="true"></p-checkbox>
    </div>
 </ng-template>
 <ng-template pTemplate="footer">
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="escondeDialog()"></button>
    <button pButton label="Salvar" icon="pi pi-check" class="p-button-text" (click)="salvar()"></button>
</ng-template>
</p-dialog>